import actionTypes from "../common/actionTypes";
import { DATABASE_STATUTES } from "../common/constants";
import { initialState } from "../common/shopConstants";

export const shopReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SHOP:
      return {
        ...state,
        error: null,
        status: DATABASE_STATUTES.LOADING,
      };

    case actionTypes.FETCH_SHOP_SUCCESS: {
      const shop = action.payload.shop;
      return {
        ...state,
        shop: {
          automations: shop.automations,
          createdAt: shop.createdAt,
          email: shop.email || "",
          error: null,
          hasScript: shop.hasScript || false,
          hasCustomScript: shop.hasCustomScript || false,
          needsScriptUpdate: shop.needsScriptUpdate || false,
          scriptVersion: shop.scriptVersion || "0.0",
          hasDoneOnboarding: shop.hasDoneOnboarding || false,
          hasReviewed: shop.hasReviewed,
          hasChatEnabled: shop.hasChatEnabled || false,
          hasMultipleProducts: shop.hasMultipleProducts || false,
          hasSellingPlanEnabled: shop.hasSellingPlanEnabled || false,
          isCSVEnabled: shop.isCSVEnabled || false,
          isDisabled: shop.isDisabled || false,
          isDisabledIS: shop.isDisabledIS || false,
          isDisabledBIS: shop.isDisabledBIS || false,
          seeV2Alert: shop.seeV2Alert || false,
          locale: shop.local || "en",
          localeApp: shop.localeApp || "en",
          name: shop.name || "",
          newBusinessModel: shop.newBusinessModel,
          orders: shop.orders,
          isAppBlockEnabled: shop.isAppBlockEnabled || false,
          customDomain: shop.customDomain,
          deepLink:
            shop.deepLink ||
            `https://${action.payload.uid}/admin/themes/current/editor?context=apps&activateAppId=bf6c109b-79b5-457c-8752-0e5e9e9676e7%2Fapp-embed`,
          settings: {
            ...state.settings,
            ...shop.settings,
          },
          subscription: shop.subscription || {},
          planType: shop.planType || "",
          features: shop.features || { isInStockEnabled: false },
          tutorial: shop.tutorial || {
            languageSelection: false,
            welcome: false,
            reviewAsked: false,
            firstStep: true,
            showAskReviewModal: shop.showAskReviewModal || false,
            showEmojiReviewModal: shop.showEmojiReviewModal || false,
          },
          uid: action.payload.uid,
          freePlan: shop.freePlan || {},
          paidPlan: shop.paidPlan || {},
          selectors: shop.selectors || {},
          hasBadReviewRisk: shop.hasBadReviewRisk || false,
          hasNewBillingPlans: shop.hasNewBillingPlans || false,
          preferences: shop.preferences || {},
          lastSettingsUpdate: !!shop.lastSettingsUpdate,
          lastProductUpdate: !!shop.lastProductUpdate,
        },
        status: DATABASE_STATUTES.LOADED,
        timesactVersion: shop.timesactVersion,
      };
    }

    case actionTypes.FETCH_SHOP_FAILURE:
      return {
        ...state,
        error: action.error,
        status: DATABASE_STATUTES.LOADED,
        shop: { ...initialState },
      };

    case actionTypes.STORE_SUBSCRIBE_CONFIRMATION_URL:
      return {
        ...state,
        subscribeConfirmUrl: action.payload,
      };

    case actionTypes.REMOVE_SUBSCRIBE_CONFIRMATION_URL:
      return {
        ...state,
        subscribeConfirmUrl: "",
      };

    case actionTypes.ASK_REVIEW:
      return {
        ...state,
        askReview: true,
      };

    case actionTypes.SEND_REVIEW:
      return {
        ...state,
        error: null,
        status: DATABASE_STATUTES.LOADING,
      };

    case actionTypes.SEND_REVIEW_SUCCESS:
      return {
        ...state,
        askReview: false,
        status: DATABASE_STATUTES.LOADED,
      };

    case actionTypes.SEND_REVIEW_FAILURE:
      return {
        ...state,
        error: action.payload,
        status: DATABASE_STATUTES.LOADED_ERROR,
      };

    case actionTypes.VALIDATE_THEME_EXTENSION_APP_ENABLED:
      return {
        ...state,
        error: null,
        status: DATABASE_STATUTES.LOADING,
      };

    case actionTypes.VALIDATE_THEME_EXTENSION_APP_ENABLED_SUCCESS:
      return {
        ...state,
        status: DATABASE_STATUTES.LOADED,
      };

    case actionTypes.VALIDATE_THEME_EXTENSION_APP_ENABLED_FAILURE:
      return {
        ...state,
        error: action.payload,
        status: DATABASE_STATUTES.LOADED_ERROR,
      };

    default:
      return state;
  }
};
